import _tslib from "tslib";
import { dew as _errorsDew } from "../errors";
import { dew as _PDFArrayDew } from "../objects/PDFArray";
import { dew as _PDFDictDew } from "../objects/PDFDict";
import { dew as _PDFNameDew } from "../objects/PDFName";
import { dew as _PDFNumberDew } from "../objects/PDFNumber";
import { dew as _Ascii85StreamDew } from "./Ascii85Stream";
import { dew as _AsciiHexStreamDew } from "./AsciiHexStream";
import { dew as _FlateStreamDew } from "./FlateStream";
import { dew as _LZWStreamDew } from "./LZWStream";
import { dew as _RunLengthStreamDew } from "./RunLengthStream";
import { dew as _StreamDew } from "./Stream";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.decodePDFRawStream = void 0;
  var tslib_1 = _tslib;

  var errors_1 = _errorsDew();

  var PDFArray_1 = tslib_1.__importDefault(_PDFArrayDew());

  var PDFDict_1 = tslib_1.__importDefault(_PDFDictDew());

  var PDFName_1 = tslib_1.__importDefault(_PDFNameDew());

  var PDFNumber_1 = tslib_1.__importDefault(_PDFNumberDew());

  var Ascii85Stream_1 = tslib_1.__importDefault(_Ascii85StreamDew());

  var AsciiHexStream_1 = tslib_1.__importDefault(_AsciiHexStreamDew());

  var FlateStream_1 = tslib_1.__importDefault(_FlateStreamDew());

  var LZWStream_1 = tslib_1.__importDefault(_LZWStreamDew());

  var RunLengthStream_1 = tslib_1.__importDefault(_RunLengthStreamDew());

  var Stream_1 = tslib_1.__importDefault(_StreamDew());

  var decodeStream = function (stream, encoding, params) {
    if (encoding === PDFName_1.default.of("FlateDecode")) {
      return new FlateStream_1.default(stream);
    }

    if (encoding === PDFName_1.default.of("LZWDecode")) {
      var earlyChange = 1;

      if (params instanceof PDFDict_1.default) {
        var EarlyChange = params.lookup(PDFName_1.default.of("EarlyChange"));

        if (EarlyChange instanceof PDFNumber_1.default) {
          earlyChange = EarlyChange.asNumber();
        }
      }

      return new LZWStream_1.default(stream, undefined, earlyChange);
    }

    if (encoding === PDFName_1.default.of("ASCII85Decode")) {
      return new Ascii85Stream_1.default(stream);
    }

    if (encoding === PDFName_1.default.of("ASCIIHexDecode")) {
      return new AsciiHexStream_1.default(stream);
    }

    if (encoding === PDFName_1.default.of("RunLengthDecode")) {
      return new RunLengthStream_1.default(stream);
    }

    throw new errors_1.UnsupportedEncodingError(encoding.asString());
  };

  exports.decodePDFRawStream = function (_a) {
    var dict = _a.dict,
        contents = _a.contents;
    var stream = new Stream_1.default(contents);
    var Filter = dict.lookup(PDFName_1.default.of("Filter"));
    var DecodeParms = dict.lookup(PDFName_1.default.of("DecodeParms"));

    if (Filter instanceof PDFName_1.default) {
      stream = decodeStream(stream, Filter, DecodeParms);
    } else if (Filter instanceof PDFArray_1.default) {
      for (var idx = 0, len = Filter.size(); idx < len; idx++) {
        stream = decodeStream(stream, Filter.lookup(idx, PDFName_1.default), DecodeParms && DecodeParms.lookupMaybe(idx, PDFDict_1.default));
      }
    } else if (!!Filter) {
      throw new errors_1.UnexpectedObjectTypeError([PDFName_1.default, PDFArray_1.default], Filter);
    }

    return stream;
  }; //# sourceMappingURL=decode.js.map


  return exports;
}